module.exports = __webpack_public_path__ + "static/img/singin2.826103f2.png";